import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ProfileHeader = ({ user, onEditProfile }) => {
  const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
  const completedEventsCount = currentUser?.completed_events_count || 0;

  return (
    <div className="bg-card rounded-xl shadow-organic p-4 md:p-6 lg:p-8 mb-4 md:mb-6">
      <div className="flex flex-col lg:flex-row gap-4 md:gap-6 items-start lg:items-center">
        <div className="relative flex-shrink-0">
          <div className="w-24 h-24 md:w-32 md:h-32 lg:w-40 lg:h-40 rounded-full overflow-hidden border-4 border-primary/20">
            <Image
              src={user?.avatar}
              alt={user?.avatarAlt}
              className="w-full h-full object-cover"
            />
          </div>
          {user?.isPro && (
            <div className="absolute -bottom-2 -right-2 bg-accent text-accent-foreground px-3 py-1 rounded-full text-xs md:text-sm font-semibold flex items-center gap-1 shadow-organic">
              <Icon name="Crown" size={14} />
              <span>PRO</span>
            </div>
          )}
        </div>

        <div className="flex-1 w-full min-w-0">
          <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 mb-3">
            <div className="min-w-0">
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-1 truncate">
                {user?.name}
              </h1>
              <p className="text-sm md:text-base text-muted-foreground">@{user?.username}</p>
            </div>
            <Button
              variant="outline"
              size="default"
              iconName="Edit"
              iconPosition="left"
              onClick={onEditProfile}
              className="w-full sm:w-auto bg-[#1B4B66] hover:bg-[#2E7D8A] text-white border-[#1B4B66] hover:border-[#2E7D8A] shadow-md hover:shadow-lg transition-all duration-200 font-semibold"
            >
              Profili Düzenle
            </Button>
          </div>

          <p className="text-sm md:text-base text-foreground/80 mb-4 line-clamp-3">
            {user?.bio}
          </p>

          <div className="flex flex-wrap gap-2 md:gap-3 mb-4">
            <div className="flex items-center gap-2 text-muted-foreground">
              <Icon name="CheckCircle" className="w-4 h-4" />
              <span className="text-sm">{completedEventsCount} Tamamlanan Etkinlik</span>
            </div>
            <div className="flex items-center gap-2 text-sm md:text-base text-muted-foreground">
              <Icon name="Calendar" size={16} />
              <span>Üyelik: {user?.memberSince}</span>
            </div>
            <div className="flex items-center gap-2 text-sm md:text-base text-muted-foreground">
              <Icon name="Award" size={16} />
              <span>{user?.experienceLevel}</span>
            </div>
          </div>

          <div className="flex flex-wrap gap-2">
            {user?.badges?.map((badge) => (
              <div
                key={badge?.id}
                className="flex items-center gap-2 bg-primary/10 text-primary px-3 py-1.5 rounded-lg text-xs md:text-sm font-medium"
                title={badge?.description}
              >
                <Icon name={badge?.icon} size={14} />
                <span>{badge?.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-3 md:gap-4 mt-6 pt-6 border-t border-border">
        <div className="text-center">
          <div className="text-xl md:text-2xl lg:text-3xl font-bold text-primary mb-1">
            {user?.stats?.eventsAttended}
          </div>
          <div className="text-xs md:text-sm text-muted-foreground">Katıldığı Etkinlik</div>
        </div>
        <div className="text-center">
          <div className="text-xl md:text-2xl lg:text-3xl font-bold text-secondary mb-1">
            {user?.stats?.spotsVisited}
          </div>
          <div className="text-xs md:text-sm text-muted-foreground">Ziyaret Edilen Spot</div>
        </div>
        <div className="text-center">
          <div className="text-xl md:text-2xl lg:text-3xl font-bold text-accent mb-1">
            {user?.stats?.reviewsGiven}
          </div>
          <div className="text-xs md:text-sm text-muted-foreground">Verilen Yorum</div>
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;